<template>
  <el-form-item 
    v-if="visible"
    :label="$t('lang.秒') + '：'">
    <el-select
      @change="handleChange"
      :disabled="disabled"
      v-model.number="localValue"
      filterable
      default-first-option
      :placeholder="$t('lang.请选择')">
      <el-option :label="0" :value="0" />
      <el-option
        v-for="item in 60"
        :key="item"
        :label="item"
        :value="item" />
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'Second',
  props: {
    // v-model 绑定的值
    value: {
      type: [Number, String],
      default: null
    },
    devMode: {
      type: Object,
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visible() {
      return this.permissions.includes('TIME_UNIT');
    },
    disabled() {
      if (!this.permissions.includes('TIME_UNIT')) return true;
      return !this.devMode?.timeChange;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>

